import { render, staticRenderFns } from "./coa-reports-totals.vue?vue&type=template&id=282fb6ae"
import script from "./coa-reports-totals.vue?vue&type=script&lang=js"
export * from "./coa-reports-totals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports